import { FC, useState, useEffect } from 'react';

import { useParams, useNavigate } from 'react-router-dom';

import { useClue } from 'hooks/useClue';
import { useGetArticleData } from 'hooks/useGetArticleData';
import { usePageTitle } from 'hooks/usePageTitle';
import { useRemoveRubyTags } from 'hooks/useRemoveRubyTags';

import { Button } from 'components/parts/Button';
import { useGetProgressQuery } from 'store/progress';

import styles from './ClueCheck.module.scss';

export const ClueCheck: FC = () => {
  const navigate = useNavigate();
  const { area } = useParams<{ area?: string }>();
  const { lastResult, isSubmittingClue, sendClue, clueNo } = useClue(Number(area) || 0);
  const [firstTime, setFirstTime] = useState(false);
  const article = useGetArticleData(area || '');
  const [inputClue, setInputClue] = useState('');
  const { refetch: refetchProgress } = useGetProgressQuery();
  const [isError, setIsError] = useState(false);
  const [IsCorrectValue, setIsCorrectValue] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (inputClue) {
      await sendClue(inputClue);
      if (!firstTime) {
        setFirstTime(true);
        setIsError(!lastResult);
      }
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputClue(event.target.value);
  };

  usePageTitle(useRemoveRubyTags(article?.name));

  useEffect(() => {
    const fetchProgressAndNavigate = async () => {
      if (lastResult) {
        setIsCorrectValue(true);
        // 0.5秒待機
        await new Promise(resolve => setTimeout(resolve, 500));

        // 「progress」を取得し、storeを更新
        await refetchProgress();

        // 完了したらnavigateを実行
        navigate(`/area/clue-result/${area}?no=${clueNo}`);
      }
    };

    fetchProgressAndNavigate();
  }, [lastResult, navigate, area, clueNo, refetchProgress]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.header}>
          <p className={styles.text}>手がかりパネルにある合言葉を入力しよう！</p>
          <div className={styles.imageWrap}>
            <img src={require('images/area/clue/info_clue.webp')} alt="" className={styles.image} />
          </div>
        </div>
        <div className={styles.body}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <label className={styles.formLabel}>
              手がかりの合言葉を入力<span className={styles.formLabelRequired}>必須</span>
            </label>
            <input
              type="text"
              value={inputClue}
              onChange={handleChange}
              placeholder="あいことば"
              disabled={isSubmittingClue}
              className={styles.formInput}
              data-error={!IsCorrectValue && isError}
            />
            {!firstTime ||
              (!lastResult && (
                <p className={styles.formMessage}>
                  <strong>手がかりボードに書かれた合言葉を正確に入力してね</strong>
                </p>
              ))}
            <div className={styles.formSubmit}>
              <Button
                text="答え合わせ"
                buttonType="submit"
                styleType="primary"
                addClass={[styles.spotButton]}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
